import React from 'react';
import img from '../Assests/Wellness/meditating_women.png';
import Arrow from "../Assests/Wellness/arrow.png"
const page3 = () => {
    return (
        <div className='well-page3-container'>
            <div className='well-page3-left'>
                <div className='well-page3-imgBG'>
                    <img src ={img} className='well-page3-img'/>
                </div>
         
                <p className='well-page3-center'>Also, get <span style={{ color: "#DA6E0B" }}>free</span> biomarker tests worth more than <span style={{ color: "#DA6E0B" }}>₹15,000</span> to track your progress</p>
                  
            </div>
            <div className='well-page3-right'>
                <p>Be part of our clinical study for a wellness program of up to 6 months. Zero Clinical visits. All from home!</p>
                <a 
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeI4GC_CLiGldUlTyvXmDyzr1_fgKPjQvTX-RNijpPnx62IMg/viewform?usp=header" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    >
                    <button className="button-wellness ">
                        <img src={Arrow} className="w-10 h-10" />
                        Express Interest
                    </button>
                </a>

            </div>
        </div>
    )
} 
export default page3;